var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.specification.value === 'Leasing')?_c('LeasingBadge'):(_vm.specification.extras.is_wanted)?_c('WantedBadge'):(_vm.specification.extras.is_rent)?_c('ForRentBadge'):[_vm._v("\n    "+_vm._s(_vm.specification.value)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }